import React, { ReactElement } from 'react';
import styled from '@emotion/styled';
import { Flex, Box } from 'reflexbox';

import { Button } from '../../../../components/Marketing/Button';
import image4 from './images/image4.png';
import { MARKETING_PAGE_BREAKPOINT_DESKTOP } from '../../../../components/Style/breakpoints';

const Container = styled(Flex)`
  flex-direction: column-reverse;
  margin-top: 40px;
  margin-bottom: 40px;
  @media only screen and (min-width: ${MARKETING_PAGE_BREAKPOINT_DESKTOP}) {
    justify-content: center;
    flex-direction: initial;
  }
`;

const SubContainer = styled(Flex)`
  flex-direction: column;
  padding: 15px;
  @media only screen and (min-width: ${MARKETING_PAGE_BREAKPOINT_DESKTOP}) {
    justify-content: center;
    // padding-left: 30px;
    width: 50%;
  }
`;

const ImageHolder = styled(Flex)`
  flex-direction: column;
  padding-left: 0px;
  @media only screen and (min-width: ${MARKETING_PAGE_BREAKPOINT_DESKTOP}) {
    justify-content: center;
    padding: 15px;
    width: 50%;
  }
  img {
    width: 100%;
    height: auto;
  }
`;

const ContainerInner = styled.div`
  max-width: 960px;
  width: 100%;
  flex-direction: row-reverse;
  display: flex;
  // padding: 2px;
  margin-bottom: 40px;
  @media only screen and (min-width: 960px) {
    padding: 12px;
    > div {
      width: 50%;
    }
    > img {
      width: 50%;
    }
    margin-bottom: 0px;
  }
  img {
    display: none;
    @media only screen and (min-width: ${MARKETING_PAGE_BREAKPOINT_DESKTOP}) {
      display: block;
    }
  }
`;

const Heading = styled.div`
  font-size: 18px;
  font-weight: 900;
  line-height: 120%;
  letter-spacing: -0.01em;
  color: #041416;
  padding-bottom: 24px;

  @media only screen and (min-width: ${MARKETING_PAGE_BREAKPOINT_DESKTOP}) {
    font-size: 26px;
  }
`;

const Description = styled(Box)`
  font-weight: normal;
  font-size: 16px;
  line-height: 140%;
  color: #7c8788;
  padding-bottom: 24px;
`;

const ButtonContainer = styled(Flex)`
  justify-content: center;
  @media only screen and (min-width: ${MARKETING_PAGE_BREAKPOINT_DESKTOP}) {
    justify-content: start;
  }
`;

export const ASXListed = (): ReactElement => {
  return (
    <Container>
      <ContainerInner>
        <ImageHolder>
          <img alt="" src={image4} />
        </ImageHolder>
        <SubContainer>
          <Heading>
            ASX-listed education company moves into non-accredited short courses
          </Heading>
          <Description>
            Diversifying business into non-accredited short courses in an online
            environment can be challenging, especially when it comes to helping
            online learners feel that they are part of a learning community.
            RedHill Education partnered with OpenLearning to transform their
            online training program and overcome key challenges.{' '}
          </Description>
          <ButtonContainer>
            <Button
              variant="secondary"
              action={{
                kind: 'external_link',
                value:
                  'https://solutions.openlearning.com/success-stories-red-hill-education/',
                target: '_blank',
              }}
            >
              Read full case study
            </Button>
          </ButtonContainer>
        </SubContainer>
      </ContainerInner>
    </Container>
  );
};
